export enum StatusQuoteImportEnum {
  Success = 1,
  Failed = 2,
  Pending = 3
}

